var map = {
	"./ar-IQ": [
		2182,
		182
	],
	"./ar-IQ.ts": [
		2182,
		182
	],
	"./en-GB": [
		9423,
		423
	],
	"./en-GB.ts": [
		9423,
		423
	],
	"./ku-IQ": [
		6568,
		568
	],
	"./ku-IQ.ts": [
		6568,
		568
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8246;
module.exports = webpackAsyncContext;